export type PAYMENT_METHOD_TYPE = 'fiat' | 'crypto' | 'card';
export enum PAYMENT_METHOD_TYPE_ENUM {
  fiat = 'fiat',
  crypto = 'crypto',
  card = 'card',
}

export interface PaymentMethod {
  id: string;
  name: string;
  currency: string;
  instruction: string;
  type: PAYMENT_METHOD_TYPE;
}